import GroupsPage from './groups-page'

export default GroupsPage
